import { render, staticRenderFns } from "./ProductionBuffer.vue?vue&type=template&id=0623060c&scoped=true&"
import script from "./ProductionBuffer.vue?vue&type=script&lang=js&"
export * from "./ProductionBuffer.vue?vue&type=script&lang=js&"
import style0 from "./ProductionBuffer.vue?vue&type=style&index=0&id=0623060c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623060c",
  null
  
)

export default component.exports